(function() {
  'use strict';
  
  // Prevent multiple initializations
  if (window.mobileAddToCartPriceInitialized) return;
  window.mobileAddToCartPriceInitialized = true;
  
  // Function to check if we're on mobile
  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }
  
  function getRechargeWidget() {
    return document.querySelector('recharge-subscription-widget');
  }

  function isRechargeSubscriptionSelected() {
    const container = document.querySelector('.product__info-container');
    return container?.dataset?.jpRcPurchaseMode === 'subscription';
  }

  function extractVisiblePriceText(element) {
    if (!element) return '';

    const clone = element.cloneNode(true);
    clone
      .querySelectorAll('.visually-hidden, .visually-hidden-label, [class*="visually-hidden"]')
      .forEach((node) => node.remove());

    return clone.textContent.replace(/\s+/g, ' ').trim().replace(/^,\s*/, '');
  }

  function getRechargeSubscriptionPrices() {
    const widget = getRechargeWidget();
    const shadow = widget?.shadowRoot;
    if (!shadow) return { current: '', compare: '' };

    const block = shadow.querySelector('.rc-purchase-option__subscription');
    const current = extractVisiblePriceText(
      block?.querySelector('.rc-purchase-option__discounted-price') ||
        block?.querySelector('[part="rc-purchase-option__discounted-price"]')
    );
    const compare = extractVisiblePriceText(
      block?.querySelector('.rc-purchase-option__original-price') ||
        block?.querySelector('[part="rc-purchase-option__original-price"]')
    );

    return { current, compare };
  }

  function getRechargeSubscriptionPrice() {
    return getRechargeSubscriptionPrices().current;
  }

  function getV3SelectedCard() {
    return document.querySelector('.jp-buybox-v3__radio:checked')?.closest('.jp-buybox-v3__card') || null;
  }

  function getV3Prices() {
    const card = getV3SelectedCard();
    return {
      current: extractVisiblePriceText(card?.querySelector('.jp-buybox-v3__price')),
      compare: extractVisiblePriceText(card?.querySelector('.jp-buybox-v3__compare'))
    };
  }

  // Function to get current price from DOM
  function getCurrentPrice() {
    let priceText = '';

    const v3Price = getV3Prices().current;
    if (v3Price) return v3Price;

    if (isRechargeSubscriptionSelected()) {
      priceText = getRechargeSubscriptionPrice();
      if (priceText) return priceText;
    }

    // 1. Subscription selected: prefer the actual selected selling plan price.
    const selectedSubscription = document.querySelector('input[data-radio-type="selling_plan"]:checked');
    if (selectedSubscription) {
      const newDomPrice = selectedSubscription.closest('label')?.querySelector('.in_widget_price');
      if (newDomPrice) {
        priceText = newDomPrice.textContent.trim();
        if (priceText) return priceText;
      }

      const allocationPrice = document.querySelector('.allocation_price');
      if (allocationPrice) {
        priceText = allocationPrice.textContent.trim();
        if (priceText) return priceText;
      }
    }

    // 2. Check for subscription price (legacy checked option)
    const checkedSubscription = document.querySelector('.shopify_subscriptions_purchase_option_wrapper.checked');
    if (checkedSubscription) {
      const subscriptionPrice = checkedSubscription.querySelector('.shopify_subscriptions_in_widget_price');
      if (subscriptionPrice) {
        priceText = subscriptionPrice.textContent.trim();
        if (priceText) return priceText;
      }
    }

    // 3. Check for custom unit price (selected one-time purchase)
    const selectedCustomRadio = document.querySelector('.custom-one-time-radio:checked');
    if (selectedCustomRadio) {
      const customUnitBox = selectedCustomRadio.closest('.custom-unit-box');
      if (customUnitBox) {
        const customPrice = customUnitBox.querySelector('.custom-unit-price');
        if (customPrice) {
          priceText = customPrice.textContent.trim();
          if (priceText && priceText.match(/[\d,\.€$£]/)) {
            return priceText;
          }
        }
      }
    }

    // 4. Check for main product price (sale or regular)
    const priceContainer = document.querySelector('[id^="price-"]') || document.querySelector('.product__block--price') || document.querySelector('.f-price');
    if (priceContainer) {
      const salePrice = priceContainer.querySelector('.f-price__sale .f-price-item--sale');
      if (salePrice) {
        priceText = salePrice.textContent.trim();
        if (priceText) return priceText;
      }
      
      const regularPrices = priceContainer.querySelectorAll('.f-price__regular .f-price-item--regular');
      for (const regularPrice of regularPrices) {
        const strikethrough = regularPrice.closest('s');
        if (!strikethrough) {
          priceText = regularPrice.textContent.trim();
          if (priceText && !priceText.toLowerCase().includes('from') && !priceText.toLowerCase().includes('desde')) {
            return priceText;
          }
        }
      }
    }
    
    return '';
  }

  // Get current compare-at price (DE) from DOM: custom-unit (.custom-unit-price-original) or subscription (data-variant-compare-at-price)
  function getCurrentComparePrice() {
    let compareText = '';

    const v3Compare = getV3Prices().compare;
    if (v3Compare) return v3Compare;

    if (isRechargeSubscriptionSelected()) {
      const rechargeCompare = getRechargeSubscriptionPrices().compare;
      if (rechargeCompare) return rechargeCompare;
    }

    // 1. Subscription selected: compare = regular price before discount.
    const selectedSellingPlan = document.querySelector('input[data-radio-type="selling_plan"]:checked');
    if (selectedSellingPlan && selectedSellingPlan.dataset.variantCompareAtPrice) {
      return selectedSellingPlan.dataset.variantCompareAtPrice.trim();
    }

    // 2. Custom unit: compare = .custom-unit-price-original (preço original da quantidade)
    const selectedCustomRadio = document.querySelector('.custom-one-time-radio:checked');
    if (selectedCustomRadio) {
      const customUnitBox = selectedCustomRadio.closest('.custom-unit-box');
      if (customUnitBox) {
        const originalEl = customUnitBox.querySelector('.custom-unit-price-original');
        if (originalEl) {
          compareText = originalEl.textContent.trim();
          if (compareText) return compareText;
        }
        if (selectedCustomRadio.dataset.variantCompareAtPrice) {
          return selectedCustomRadio.dataset.variantCompareAtPrice.trim();
        }
        const customCompare = customUnitBox.querySelector('.compare-at-price');
        if (customCompare) {
          compareText = customCompare.textContent.trim();
          if (compareText) return compareText;
        }
      }
    }

    // Wrapper "checked" pode ter o preço de referência (one-time) como compare
    const checkedSubscriptionWrapper = document.querySelector('.shopify_subscriptions_purchase_option_wrapper.checked');
    if (checkedSubscriptionWrapper) {
      const oneTimeOption = document.querySelector('input[data-radio-type="one_time_purchase"]');
      if (oneTimeOption && oneTimeOption.dataset.variantPrice) {
        return oneTimeOption.dataset.variantPrice.trim();
      }
    }

    // 3. Main price block (bloco de preço da variante)
    const priceContainer = document.querySelector('[id^="price-"]') || document.querySelector('.product__block--price') || document.querySelector('.f-price');
    if (priceContainer) {
      const saleBlock = priceContainer.querySelector('.f-price__sale');
      if (saleBlock) {
        const struck = saleBlock.querySelector('s .f-price-item--regular');
        if (struck) return struck.textContent.trim();
      }
    }
    return '';
  }

  // Normalize price string for comparison (trim, remove all spaces so "44,90 €" === "44,90€")
  function normalizePriceForCompare(str) {
    if (!str || typeof str !== 'string') return '';
    return str.trim().replace(/\s/g, '');
  }

  // Compare price (DE) only shows for: 2 units, 3 units, or subscription. Never for 1 unit or when DE === POR.
  function updatePriceDePorBlocks() {
    const blocks = document.querySelectorAll('.ru-price-de-por');
    if (blocks.length === 0) return;
    const currentPrice = getCurrentPrice();
    let comparePrice = getCurrentComparePrice();

    const selectedCustomRadio = document.querySelector('.custom-one-time-radio:checked');
    const isSubscriptionSelected =
      isRechargeSubscriptionSelected() || !!document.querySelector('input[data-radio-type="selling_plan"]:checked');

    if (selectedCustomRadio) {
      const qty = parseInt(selectedCustomRadio.value, 10);
      if (qty === 1 && (!comparePrice || normalizePriceForCompare(comparePrice) === normalizePriceForCompare(currentPrice))) {
        comparePrice = '';
      }
    } else if (!isSubscriptionSelected && (!comparePrice || normalizePriceForCompare(comparePrice) === normalizePriceForCompare(currentPrice))) {
      comparePrice = '';
    }
    const currentNorm = normalizePriceForCompare(currentPrice);
    const compareNorm = normalizePriceForCompare(comparePrice);
    if (compareNorm && currentNorm && compareNorm === currentNorm) {
      comparePrice = '';
    }
    const currentNormFinal = normalizePriceForCompare(currentPrice);
    const compareNormFinal = normalizePriceForCompare(comparePrice);
    const showCompare = comparePrice && compareNormFinal !== currentNormFinal;

    blocks.forEach(function (block) {
      const valuesEl = block.querySelector('.ru-price-de-por__values');
      if (!valuesEl) return;
      let html = '';
      if (showCompare) {
        html += '<s class="ru-price-de-por__compare">' + comparePrice + '</s>';
      }
      html += '<span class="ru-price-de-por__current">' + (currentPrice || '') + '</span>';
      valuesEl.innerHTML = html;
    });
  }
  
  // Function to get "add" text from button data attribute
  function getAddText(buttonSpan) {
    // Get from button's data-add-text attribute (set via Liquid translation)
    const button = buttonSpan.closest('.product-form__submit');
    if (button && button.dataset.addText) {
      return button.dataset.addText;
    }
    // Fallback: try to extract from original text
    // Remove everything after the first word (works for all languages)
    if (buttonSpan.dataset.originalText) {
      const original = buttonSpan.dataset.originalText.trim();
      // Split by space and take only the first word
      const firstWord = original.split(/\s+/)[0];
      return firstWord || 'Add';
    }
    // Last fallback
    return 'Add';
  }
  
  // Function to update all button texts
  function updateButtonTexts(forceUpdate) {
    const buttons = document.querySelectorAll('.product-form__submit span');
    if (buttons.length === 0) return;
    
    buttons.forEach(buttonSpan => {
      // Skip buttons inside packs-and-conbinations--wrapper (combos/upsells)
      const button = buttonSpan.closest('.product-form__submit');
      if (button && button.closest('.packs-and-conbinations--wrapper')) {
        return;
      }
      
      // Store original text if not already stored
      if (!buttonSpan.dataset.originalText) {
        const currentText = buttonSpan.textContent.trim();
        if (currentText && !currentText.toLowerCase().includes('sold') && !currentText.toLowerCase().includes('agotado')) {
          buttonSpan.dataset.originalText = currentText;
        }
      }
      
      // Skip if button shows "sold out"
      const currentText = buttonSpan.textContent.trim();
      if (currentText.toLowerCase().includes('sold') || currentText.toLowerCase().includes('agotado')) {
        return;
      }
      
      // Update with price (works for both mobile and desktop)
      const price = getCurrentPrice();
      if (!price) {
        if (buttonSpan.dataset.originalText) {
          buttonSpan.textContent = buttonSpan.dataset.originalText;
        }
        return;
      }
      
      const addText = getAddText(buttonSpan);
      // Price comes BEFORE the text: "31,80€ - añadir al carrito"
      const newText = price + ' - ' + addText;
      buttonSpan.textContent = newText;
    });
  }
  
  function runPriceUpdates() {
    updateButtonTexts();
    updatePriceDePorBlocks();
  }

  let priceUpdateTimer;

  function scheduleRunPriceUpdates(delay) {
    window.clearTimeout(priceUpdateTimer);
    priceUpdateTimer = window.setTimeout(runPriceUpdates, delay || 80);
  }

  window.runPriceUpdates = runPriceUpdates;

  // Initialize
  function init() {
    scheduleRunPriceUpdates(300);

    // Listen for variant changes via pubsub and custom event
    if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function() {
        scheduleRunPriceUpdates(100);
      });
    }
    document.addEventListener('variant:changed', function() {
      scheduleRunPriceUpdates(100);
    });

    document.addEventListener('change', function(e) {
      if (
        e.target.matches(
          'input[data-radio-type="selling_plan"], input[data-radio-type="one_time_purchase"], .custom-one-time-radio, .quantity__input'
        )
      ) {
        scheduleRunPriceUpdates(100);
      }
    });

    document.addEventListener('jp-recharge-widget:updated', function() {
      scheduleRunPriceUpdates(120);
    });

    document.addEventListener('click', function(e) {
      if (e.target.closest('.custom-unit-box, recharge-subscription-widget')) {
        scheduleRunPriceUpdates(120);
      }
    });

    let resizeTimeout;
    window.addEventListener('resize', function() {
      window.clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(runPriceUpdates, 150);
    });
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

